import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconButtonWithLabel } from '../buttons/icon_button_with_label';
export const SelectableIconButtonWithLabel = ({ color, isSelectedYn, selectedColor, ...rest }) => {
    return (_jsx(IconButtonWithLabel, { iconName: "MarkerIcon", label: "Marker", color: isSelectedYn ? selectedColor : color, skipHoverStyling: isSelectedYn, ...rest }));
};
//# sourceMappingURL=selectable_icon_button_with_label.js.map